import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchFun } from '../../../../utils/fetchFun';

export const fetchFNPlaceholders = createAsyncThunk(
    'user/fetchFNPlaceholders',
    async () => {
        try {
            const response = await fetchFun(`/api/v1/footnote/placeholder`, 'GET');
            // if(response?.success) {
                return response?.data
            // }

        } catch(error) {
            console.log("Error - /api/v1/footnote/placeholder", error)
            // return response?.data
        }
    }
);

export const fetchSavedFN = createAsyncThunk(
    'user/fetchSavedFN',
    async ({user}) => {
        try {
            const response = await fetchFun(`/api/v1/footnote/notes/${user._id}`, 'GET');
            // if(response?.success) {
                return response?.data
            // }

        } catch(error) {
            console.log("Error - /api/v1/footnote/placeholder", error)
            // return response?.data
        }
    }
);

export const fetchSavedFNForms = createAsyncThunk(
    'user/fetchSavedFNForms',
    async ({user}) => {
        try {
            const response = await fetchFun(`/api/v1/footnote/form/${user._id}`, 'GET');
            // if(response?.success) {
                return response?.data
            // }

        } catch(error) {
            console.log("Error - /api/v1/footnote/placeholder", error)
            // return response?.data
        }
    }
);